<div class="modal_dialog">
  <div class="modal_header">
    <h2>{{ 'SerialNumberInput' | translate }}</h2>
    <button class="btnn close_icon" type="button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal_body">
    <form [formGroup]="serialNumberForm">
      <div class="gap_m">
        <div class="form_group w_100">
          <mat-label class="required">
            {{ 'SerialNumber' | translate }}
          </mat-label>
          
          <div class="chip-container">
            <div class="chips-wrapper" *ngIf="serialNumbers.length > 0">
              <div class="chip" *ngFor="let serialNumber of serialNumbers; let i = index">
                <span class="chip-text">{{serialNumber}}</span>
                <button type="button" class="chip-remove" (click)="remove(serialNumber)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
            
            <mat-form-field appearance="fill" class="chip-input-field">
              <mat-icon matPrefix>qr_code_scanner</mat-icon>
              <input
                matInput
                placeholder="{{ 'EnterSerialNumberOrScanBarcode' | translate }}"
                class="form_control"
                type="text"
                formControlName="serialNumber"
                (keypress)="onKeyPress($event)"
                (input)="onSerialNumberChange($event)"
                autofocus />
            </mat-form-field>
            
            <mat-error *ngIf="serialNumberForm.get('serialNumber')?.hasError('required') && serialNumbers.length === 0">
              {{ 'SerialNumberRequired' | translate }}
            </mat-error>
          </div>
          
          <div class="help-text">
            <div class="help-content">
              <mat-icon class="help-icon">info</mat-icon>
              <div class="help-details">
                <p>{{ 'SerialNumberHelpText' | translate }}</p>
                <ul>
                  <li>{{ 'PressEnterOrCommaToAddASerialNumber' | translate }}</li>
                  <li>{{ 'ClickTheXButtonToRemoveASerialNumber' | translate }}</li>
                  <li>{{ 'YouCanScanBarcodesOrTypeManually' | translate }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Modal Footer -->
  <div class="modal_footer">
    <div class="action-buttons">
      <button class="btnn btn_secondary" type="button" (click)="onCancel()">
        {{ 'Cancel' | translate }}
      </button>
      <button class="btnn btn_primary" type="button" [disabled]="!isFormValid()" (click)="onConfirm()">
        {{ 'Confirm' | translate }}
      </button>
    </div>
  </div>
</div> 